import React from 'react';
import { ClassicPdpBreadcrumbs } from './breadcrumbs/classic-pdp-breadcrumbs';
import { ClassicPdpBreadcrumb, ClassicPdpUpsell } from './classic-pdp-content';
import { UpsellCards } from './upsell-cards/upsell-cards';

export interface ClassicPdpLayoutProps {
  breadcrumbs: ClassicPdpBreadcrumb[];
  visuals: React.ReactNode;
  actions: React.ReactNode;
  upsell: ClassicPdpUpsell;
}

/**
 * Classic two-column detail layout shared by the product and the bundle section:
 * a breadcrumb trail on top, visuals on the left, the purchase column on the
 * right (sticky from `lg` up), and the upsell offers across the full width
 * underneath. Below `lg` the DOM order alone produces the single column.
 */
export function ClassicPdpLayout({
  breadcrumbs,
  visuals,
  actions,
  upsell,
}: Readonly<ClassicPdpLayoutProps>) {
  return (
    // The shared Container clips overflow on the x axis, which breaks the
    // sticky column, so the classic section brings its own wrapper.
    <div
      data-testid="classic-pdp-main"
      className="mx-auto max-w-screen-2xl px-4 py-8 sm:px-8 sm:py-14"
    >
      <ClassicPdpBreadcrumbs crumbs={breadcrumbs} />

      <div
        data-testid="classic-pdp-grid"
        className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12"
      >
        <div data-testid="classic-pdp-visuals" className="lg:col-span-7">
          {visuals}
        </div>

        <div
          data-testid="classic-pdp-actions"
          className="lg:sticky lg:top-28 lg:col-span-5 lg:self-start"
        >
          {actions}
        </div>
      </div>

      <UpsellCards items={upsell.items} title={upsell.title} subtitle={upsell.subtitle} />
    </div>
  );
}
